import type { ITabItemsProps } from "@/shared/common/types";

import { TransactionTab } from "../common/enum";

export const getTransactionTabItems = ({ t }: ITabItemsProps) => [
  {
    value: TransactionTab.Transfers,
    label: t("transactions.transfers"),
    dataId: "transfer-tab",
    disabled: false,
  },
  {
    value: TransactionTab.Payments,
    label: t("transactions.payments"),
    dataId: "payment-tab",
    disabled: false,
  },
];
